module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter001#ch1"
    }
  }, [_vm._v("Chapter 1: Good intentions but clueless")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter001#sec1"
    }
  }, [_vm._v("“Do your business, Gretchen!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter001#sec2"
    }
  }, [_vm._v("Dealing with dog doo: a speed-of-light history")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter001#sec3"
    }
  }, [_vm._v("Cat poo: another story altogether")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter001#sec4"
    }
  }, [_vm._v("How did I get into this crap?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter001#sec5"
    }
  }, [_vm._v("Piled higher and deeper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter001#sec6"
    }
  }, [_vm._v("You take it. No, YOU take it")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Chapter001#sec7"
    }
  }, [_vm._v("Oh, ick…NOT!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter002#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Before we start: Five more preliminary items")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hazards")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Start with healthy dogs and cats")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Location, location, location")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The great pickup bag charade")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter002#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heavy metals and pharmas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: And so we begin: Best practices for pet waste recycling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec13"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Recycle” vs. “upcycle”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec14"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flushing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec15"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burial")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec16"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biodigestion/septic bin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec17"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bokashi (Essential Microorganisms/EM)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec18"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Composting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec19"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moldering")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec20"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vermiculture (cultivating worm poop)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Mission possible: “gold star” DW compost")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec21"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter004#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down the rabbit hole")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "rsec22"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter004#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plant power unleashed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rbm1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Notes#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocv",
    attrs: {
      "id": "rbm2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Acknowledgements#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocv",
    attrs: {
      "id": "rbm3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Index#bm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocv",
    attrs: {
      "id": "rbm4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Abouttheauthor#bm4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0